import { Injectable, signal } from '@angular/core';

export type ToastType = 'success' | 'error';

export interface Toast {
  id: number;
  type: ToastType;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private _counter = 0;
  private readonly _toasts = signal<Toast[]>([]);
  private readonly _timers = new Map<number, ReturnType<typeof setTimeout>>();
  readonly toasts = this._toasts.asReadonly();

  success(message: string): void {
    this._add('success', message);
  }

  error(message: string): void {
    this._add('error', message);
  }

  dismiss(id: number): void {
    clearTimeout(this._timers.get(id));
    this._timers.delete(id);
    this._toasts.update((list) => list.filter((t) => t.id !== id));
  }

  private _add(type: ToastType, message: string): void {
    const id = ++this._counter;
    this._toasts.update((list) => [...list, { id, type, message }]);
    this._timers.set(
      id,
      setTimeout(() => this.dismiss(id), 4000),
    );
  }
}
